<template>
<button type="button" class="btn favorite" :class="{ active: isFavoriteActive }" aria-label="Favorito"
    :title="isFavoriteActive ? `Remover dos favoritos` : `Adicionar aos favoritos`" @click="OnFavoriteClick">
    <i class="far fa-heart"></i>
</button>
</template>



<script>

// --------------------------------------------------------
// -----------------WARNING--------------------------------
// --------------------------------------------------------
// this component is depracated, use c# component instead

import * as Constants from "../scripts/constants"
import UserClientService from "../scripts/services/userClient.js"


export default {

    data() {
        return {
            isFavoriteActive: false,
        }
    },
    props: {
        IdPub: {
            type: Number,
            default: 0
        },
        IsFavorite: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.isFavoriteActive = this.IsFavorite == true;
    },
    methods: {
        async OnFavoriteClick() {
            var r = await UserClientService.SetFavorite(this.IdPub);
            if (r != null) {
                if (r.OK) {
                    this.isFavoriteActive = !this.isFavoriteActive;

                    this.$emit('SetFavoriteSuccess', { IsFavorite: this.IsFavorite, IdPub: this.IdPub });
                } else {
                    if (r.StatusCode == Constants.HTTP_STATUS_CODE_UNAUTHORIZED) {
                        this.isFavoriteActive = false;
                        
                        
                        if ($("#favoritesLoginModal").length > 0)
                        {
                            $("#favoritesLoginModal").modal();
                        }
                        else
                        {
                            if ($("#loginModal").length > 0)
                            {
                                $("#loginModal").modal();
                            }else{
                                UserClientService.OnUnauthorized();
                            }
                        }
                    }
                }
            }
        }
    }

};
</script>